import type * as ModelType from "@/components/features/faq/model/type";

/**
 *
 * @description contents から categoryName を key として、unique な categoryNames を返す
 *
 * @param contents {Array<ModelType.Content>}
 *
 * @returns {Array<string>}
 *
 */
export const uniqueCategoriesFilter = (contents: Array<ModelType.Content>): Array<string> => {
	const uniqueCategoryMap = new Map<string, { name: string }>();
	// contents から category を取り出し、重複を排除する
	for (const content of contents) {
		// unique key = category name
		uniqueCategoryMap.set(content.categoryName, { name: content.categoryName });
	}

	const categories: Array<string> = [];
	for (const category of uniqueCategoryMap.values()) {
		categories.push(category.name);
	}

	return categories;
};
